import { render, staticRenderFns } from "./adminPage.vue?vue&type=template&id=322e4b7c&scoped=true"
import script from "./adminPage.vue?vue&type=script&lang=js"
export * from "./adminPage.vue?vue&type=script&lang=js"
import style0 from "./adminPage.vue?vue&type=style&index=0&id=322e4b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e4b7c",
  null
  
)

export default component.exports